var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectoruP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33404 0C5.55138 0 5.75538 0.106 5.88004 0.284667L10.5467 6.95133C10.6894 7.15467 10.7054 7.42067 10.592 7.64133C10.4767 7.862 10.2494 8 10.0007 8H0.666044C0.417377 8 0.190044 7.862 0.0747104 7.64133C-0.038623 7.42067 -0.022623 7.15467 0.120044 6.95133L4.78671 0.284667C4.91138 0.106 5.11538 0 5.33271 0H5.33404Z",
    fill: "#FFC800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectoruP);
export default __webpack_public_path__ + "static/media/VectoruP.4e9617531cf2bff796d524a67fb3d09c.svg";
export { ForwardRef as ReactComponent };